import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { describe } from 'react-desc';
import GroupItem from '@elliemae/ds-shared/GroupContext/GroupItem';
import Group from '@elliemae/ds-shared/GroupContext/Group';
import DSFormItemLayout from '../FormItem/DSFormItemLayout.js';
import '../FormItem/Error/DSError.js';
import DSRadio from '../Radio/DSRadio.js';
import { props } from './props.js';
import { defaultProps } from './defaultProps.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/getComponentFromProps';
import '../InputGroup/DSInputGroup.js';
import '../InputGroup/AddonWrapper.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '../InputGroup/props.js';
import '../InputGroup/defaultProps.js';
import '../FloatingLabelInput/DSFloatingLabelInput.js';
import '../FloatingLabelInput/FloatingLabelInputImpl.js';
import '@elliemae/ds-text-wrapper';
import 'resize-observer';
import '../FloatingLabelInput/getSvgPath.js';
import '../RequiredMark/RequiredMark.js';
import '../FormItem/Label/DSLabel.js';
import 'prop-types';
import '@elliemae/ds-truncated-tooltip-text';
import '../TextBox/DSTextBox.js';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import 'lodash';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import '../FormItem/props.js';
import '../FormItem/variants.js';
import '../FormItem/defaultProps.js';
import '../FormItem/Feedback.js';
import '../FormItem/Suffix/Suffix.js';
import 'styled-components';
import '../Radio/Circle.js';
import '@elliemae/ds-system';
import 'polished';
import '../prop-types-cc01d273.js';

var emClassPrefix = 'em-ds';
var baseClass = "".concat(emClassPrefix, "-radio-group");

var RadioItem = function RadioItem(props) {
  return /*#__PURE__*/React.createElement(GroupItem, {
    render: function render(context) {
      return /*#__PURE__*/React.createElement(DSRadio, _extends({}, props, {
        checked: context.activeValue === props.value,
        disabled: context.disabled || props.disabled,
        onChange: context.onChange
      }));
    }
  });
};

var DSRadioGroup = function DSRadioGroup(_ref) {
  var containerProps = _ref.containerProps,
      onChange = _ref.onChange,
      activeValue = _ref.activeValue,
      children = _ref.children,
      orientation = _ref.orientation,
      disabled = _ref.disabled,
      truncateText = _ref.truncateText,
      labelProps = _ref.labelProps;
  var checkRefs = [];
  var count = React.Children.count(children);

  var _onKeyDown = function onKeyDown(e, index) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      if (index === 0) checkRefs[count - 1].focus();else checkRefs[index - 1].focus();
    }

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      if (index === count - 1) checkRefs[0].focus();else checkRefs[index + 1].focus();
    }
  };

  var group = /*#__PURE__*/React.createElement(Group, {
    activeValue: activeValue,
    disabled: disabled,
    onChange: onChange
  }, /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "ds-radiogroup"
  }, labelProps && labelProps.labelText ? {} : containerProps, {
    className: "".concat(baseClass, " ").concat(baseClass, "--").concat(orientation),
    role: "group"
  }), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement(RadioItem, _extends({}, child.props, {
      innerRef: function innerRef(t) {
        checkRefs.push(t);
      },
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e, index);
      }
    }));
  }, null)));

  if (labelProps && labelProps.labelText) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "".concat(baseClass, "-form-item-layout-wrapper")
    }, containerProps, {
      role: "group"
    }), /*#__PURE__*/React.createElement(DSFormItemLayout, _extends({}, labelProps, {
      inputComponent: group,
      onChange: onChange,
      truncateText: truncateText
    })));
  }

  return group;
};

DSRadioGroup.propTypes = props;
DSRadioGroup.defaultProps = defaultProps;
var DSRadioGroupWithSchema = describe(DSRadioGroup);
DSRadioGroupWithSchema.propTypes = props;

export default DSRadioGroup;
export { DSRadioGroupWithSchema };
//# sourceMappingURL=DSRadioGroup.js.map
